<!--
 * @Author: WLL
 * @Date: 2020-04-14 12:09:24
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-09 14:16:05
 * @Description: 个股盈利预测
 -->
<template>
  <div class="stock">
    <div class="stock_above">
      <div class="stock_filter_row">
        <FilterItem label="标题检索" class="filter-item-content">
          <SjInput
            style="width: 203px;"
            placeholder="请输入关键词"
            border
            v-model="searchText"
          ></SjInput>
        </FilterItem>
        <FilterItem label="股票" class="filter-item-content">
          <SjAutoComplete
            @click.native="onFilterClick('证券')"
            v-model="stockSelected"
            :options="stockList"
            style="width: 143px;"
            placeholder="选择代码/名称"
            clearable
            @scrollBottom="onStockFilterScrollBottom"
            async
            @filter="onStockFilter"
            @change="onStockFilterChanged"
            :total="stockTotalCount"
            filterable
            filterClearable
          ></SjAutoComplete>
        </FilterItem>
        <FilterItem label="机构" class="filter-item-content">
          <SjAutoComplete
            v-model="orgSelected"
            :options="orgList"
            style="width: 143px;"
            @click.native="onFilterClick('机构')"
            placeholder="选择机构名称"
            clearable
            filterable
            filterClearable
            filterImmediately
          ></SjAutoComplete>
        </FilterItem>
        <!-- <FilterItem label="作者" class="filter-item-content">
          <SjAutoComplete
            v-model="authorSelected"
            :options="authorList"
            style="width: 143px;"
            placeholder="输入研报作者"
          ></SjAutoComplete>
        </FilterItem> -->
        <FilterItem label="行业" class="filter-item-content">
          <SelectIndustry
            @secondChange="onSecondChanged"
            v-model="industrySelected"
            :type.sync="industryType"
            @click.native="onFilterClick('行业')"
          ></SelectIndustry>
        </FilterItem>
        <FilterItem label="其他条件" class="filter-item-content">
          <SjAutoComplete
            style="width: 80px;"
            @click.native="onFilterClick('页数')"
            placeholder="页数"
            v-model="pageSelected"
            :options="pageList"
            clearable
          ></SjAutoComplete>
          <SjAutoComplete
            style="width: 80px;margin-left: 5px;"
            placeholder="评级"
            @click.native="onFilterClick('评级')"
            v-model="gradeSelected"
            :options="gradeList"
            clearable
          ></SjAutoComplete>
          <SjAutoComplete
            @click.native="onFilterClick('评级变动')"
            style="width: 95px;margin-left: 5px;"
            placeholder="评级变动"
            v-model="gradeChangeSelected"
            :options="gradeChangeList"
            clearable
          ></SjAutoComplete>
        </FilterItem>
        <FilterItem label="报告发布时间" class="filter-item-content">
          <el-date-picker
            :editable="false"
            start-placeholder="开始日期"
            style="height: 30px; margin-left: 5px; width: 250px"
            end-placeholder="结束日期"
            @click.native="onFilterClick('日期')"
            v-model="dateSelected"
            type="daterange"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
            range
            clearable
          ></el-date-picker>
        </FilterItem>
        <FilterItem label="作者" class="filter-item-content">
          <SjInput
            style="width: 203px;"
            placeholder="请输入关键词"
            border
            v-model="allresearcherText"
          ></SjInput>
        </FilterItem>
      </div>
      <SjButton
        class="stock_filter_button"
        style="margin-right: 20px;width: 106px;"
        @click="search"
      >
        搜索
      </SjButton>
    </div>
    <SjCard class="stock_below" v-sj-loading="tableLoading">
      <DisplayArea
        title="个股盈利预测"
        iconClass="icon_xh iconicon_ranking"
        iconSize="14px"
        :showMore="false"
        iconColor="#399BFF"
      >
        <common-table
          :data="tableData"
          center
          :columns="tableColumns"
          :tableProps="tableProps"
          :scrollDisabled="totalPage !== 0 && totalPage < pageNo"
          @infiniteScroll="getMoreTableData"
          @cell-click="reportClickWrapper"
        ></common-table>
      </DisplayArea>
    </SjCard>
  </div>
</template>

<script>
import FilterItem from "@/components/FilterItem.vue";
import SelectIndustry from "@/components/SelectIndustry";
import reportMixin from "@/views/mixins/reportMixin";
import { pageList, gradeList, gradeChangeList } from "@/utils/const";
import CommonTable from "@/components/CommonTable/index";
import DisplayArea from "@/components/DisplayArea";

export default {
  mixins: [reportMixin],
  components: {
    DisplayArea,
    CommonTable,
    FilterItem,
    SelectIndustry
  },
  data() {
    return {
      searchType: "title",
      searchList: [
        {
          label: "标题检索",
          value: "title"
        }
      ],
      searchText: null,
      allresearcherText: null,

      stockSelected: null,
      stockList: [],
      stockLoading: false,

      orgSelected: null,
      orgList: [],
      orgLoading: false,

      // authorSelected: null,
      // authorList: [],

      industrySelected: [],
      industryType: "011",

      pageSelected: null,
      pageList,

      gradeSelected: null,
      gradeList,

      gradeChangeSelected: null,
      gradeChangeList,

      dateSelected: null,

      stockParams: {
        pageSize: 50,
        pageNo: 1,
        V_KEYWORD: ""
      },
      stockTotalCount: 0,
      stockSelectedCache: null,

      tableData: [],
      tableColumns: [
        {
          prop: "V_PUBLISHDATE",
          label: "日期",
          minWidth: 80,
          center: true,
          formatter: this.publishDateFormatter
        },
        {
          prop: "SECURITYNAME",
          label: "股票",
          center: true,
          minWidth: 80,
          customRender: this.stockRender
        },
        {
          prop: "V_REPORTTITLE",
          label: "标题",
          minWidth: 170,
          customRender: this.ellipsisPointerRender
        },
        {
          prop: "COMPANYNAME",
          label: "机构",
          center: true,
          minWidth: 60
        },
        {
          prop: "V_ALLRESEARCHER",
          center: true,
          label: "作者",
          minWidth: 80,
          customRender: this.researcherRender
        },
        {
          prop: "V_EMRATINGNAME",
          label: "评级",
          minWidth: 60,
          center: true,
          customRender: this.ratingRender
        },
        {
          prop: "V_RATINGCHANGE",
          label: "评级变动",
          center: true,
          minWidth: 60
        },
        {
          prop: "AIMPRICET",
          label: "目标价位",
          center: true,
          minWidth: 60
        },
        {
          prop: "V_PAGES",
          center: true,
          label: "页数",
          minWidth: 40
        },
        {
          prop: "attachment",
          label: "附件",
          center: true,
          minWidth: 40,
          align: "center",
          customRender: this.pdfIconRender
        }
      ],
      tableProps: {},
      tableLoading: true,

      pageNo: 1,
      pageSize: 80,
      totalPage: 0
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      if (this.$route.query.allresearcher) {
        this.allresearcherText = this.$route.query.allresearcher;
      }
      await this.getFilters();
      await this.search();
      await this.onStockFilter("");
    },
    onExpandChanged(key, value, name) {
      this.onFilterClick("行业", name);
    },
    onSecondChanged(name) {
      this.onFilterClick("行业", name);
    },
    onFilterClick(first_screening, second_screening = "") {
      window.sendEvent("click_filter", {
        page_type: "个股盈利预测",
        first_screening: first_screening,
        second_screening: second_screening
      });
    },
    reportClickWrapper(params, column) {
      const property = column.property;
      if(["V_REPORTTITLE"].includes(property)){
        this.onReportClick(params, {
          upstream_page_type: "个股盈利预测",
          upstream_page_modular: "列表"
        });
      }
    },
    onStockFilterChanged(value) {
      this.stockSelectedCache = this.stockList.find(
        item => item.value === value
      );
    },
    onStockFilterScrollBottom() {
      this.stockParams.pageNo++;
      this.getStockList();
    },
    async onStockFilter(val) {
      this.stockParams.pageNo = 1;
      this.stockParams.V_KEYWORD = "%" + (val ? val : "") + "%";
      this.stockList = [];
      if (this.stockSelectedCache) {
        this.stockList.push(this.stockSelectedCache);
      }
      await this.getStockList();
    },
    async getFilters() {
      await this.getStockList();
      await this.getAgencyList();
    },
    async getStockList() {
      if (this.stockLoading) {
        return;
      }
      try {
        this.stockLoading = true;
        const { data, page } = await this.$apis.Base.getStockList(
          this.stockParams
        );
        this.stockTotalCount = page.totalCount;
        let stockList = data.map(v => ({
          label: v.SECURITYNAME + "(" + v.SECURITYCODE + ")",
          value: v.SECURITYCODE
        }));
        if (this.stockSelectedCache) {
          const cacheValueIndex = stockList.findIndex(item => {
            return item.value === this.stockSelectedCache.value;
          });
          if (~cacheValueIndex) {
            stockList.splice(cacheValueIndex, 1);
          }
        }
        this.stockList.push(...stockList);
      } finally {
        this.stockLoading = false;
      }
    },
    async getAgencyList() {
      try {
        this.orgLoading = true;
        const { data } = await this.$apis.Base.getAgencyList();
        this.orgList = data.map(v => ({
          label: v.COMPANYNAME,
          value: v.COMPANYCODE
        }));
        if (this.$route.query.agency_name) {
          const obj = this.orgList.find(
            item => item.label === this.$route.query.agency_name
          );
          if (obj) {
            this.orgSelected = obj.value;
          }
        }
      } finally {
        this.orgLoading = false;
      }
    },
    search() {
      this.getTableData();
    },
    getTableData() {
      this.pageNo = 1;
      this.totalPage = 0;
      this.tableData = [];
      this.getMoreTableData(true);
    },
    async getMoreTableData(init = false) {
      try {
        this.tableLoading = true;
        // 生成params
        const params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          V_INDUCODE: `${this.industryType}%`
        };
        const keyMap = {
          searchText: "V_REPORTTITLE",
          allresearcherText: "V_ALLRESEARCHER",
          stockSelected: "V_SECURITYCODE",
          orgSelected: "V_COMPANYCODE",
          gradeSelected: "V_EMRATINGNAME",
          gradeChangeSelected: "V_RATINGCHANGE"
        };
        Object.keys(keyMap).forEach(key => {
          if (this[key]) {
            Object.assign(params, {
              [keyMap[key]]:
                key === "searchText" || key === "allresearcherText"
                  ? `%${this[key]}%`
                  : this[key]
            });
          }
        });
        const { pageSelected } = this;
        if (pageSelected) {
          const pageList = pageSelected.split("-").map(val => parseInt(val));
          if (pageList.length) {
            Object.assign(params, {
              V_PAGES1: pageList[0]
            });
            if (pageList[1]) {
              Object.assign(params, {
                V_PAGES2: pageList[1]
              });
            }
          }
        }
        const { industrySelected, dateSelected } = this;
        if (Array.isArray(industrySelected) && industrySelected.length) {
          Object.assign(params, {
            V_INDUCODE: industrySelected[0]
          });
        }
        if (Array.isArray(dateSelected) && dateSelected.length) {
          const startDate = new Date(dateSelected[0]);
          const endDate = new Date(dateSelected[1]);
          const start =
            startDate.getFullYear() +
            "-" +
            (startDate.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            startDate
              .getDate()
              .toString()
              .padStart(2, "0");

          const end =
            endDate.getFullYear() +
            "-" +
            (endDate.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            endDate
              .getDate()
              .toString()
              .padStart(2, "0");
          Object.assign(params, {
            V_PUBLISHDATE1: start + " 00:00:00",
            V_PUBLISHDATE2: end + " 23:59:59"
          });
        }
        const { data, page } = await this.$apis.Stock.getStockList(params);
        this.pageNo += 1;
        this.totalPage = page.totalPage;
        if (init) {
          this.tableData = data;
        } else {
          data.forEach(v => {
            this.tableData.push(v);
          });
        }
      } finally {
        this.tableLoading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.title-search {
  /deep/.sj-autocomplete-inputWrapper {
    pointer-events: none;
  }
}
.stock {
  display: flex;
  flex-direction: column;
  .stock_above {
    display: flex;
    border-bottom: 1px solid @color-splitline-xh;
    padding: 12px 17px 0;
    margin-bottom: 10px;

    .stock_filter_row {
      flex: 1;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      overflow: hidden;
      .filter-item-content {
        margin-right: 15px;
        margin-bottom: 15px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }

    .stock_filter_button {
      flex-shrink: 0;
      &.theme-1 {
        color: @color-antibg;
        background: @color-highlight-xh;
        &:hover {
          border-color: @color-highlight-xh;
        }
      }
    }
  }
  .stock_below {
    flex: 1;
    min-height: 0;
    margin: 0 10px;
  }
}
/deep/.el-date-editor .el-range__icon {
  line-height: initial;
}
/deep/.el-range-separator {
  line-height: initial;
}
/deep/.el-input__inner,
/deep/.el-range-input {
  background-color: #fafbfc;
}
/deep/.el-range-editor.is-active,
.el-range-editor.is-active:hover {
  border-color: #0064ff;
}
/deep/.el-range__close-icon {
  display: flex;
  line-height: inherit;
  align-items: center;
}
</style>
